import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20atmosphere%20with%20red%20carpet%20and%20paparazzi%20camera%20flashes%2C%20abstract%20artistic%20rendering%20of%20celebrity%20event%20backdrop%20with%20deep%20black%20and%20crimson%20accents%2C%20bokeh%20lights%2C%20cinematic%20lighting%2C%20mysterious%20and%20glamorous%20mood%2C%20editorial%20photography%20style%2C%20high%20contrast%20noir%20aesthetic&width=1920&height=1080&seq=hero-baogua-bg&orientation=landscape"
          alt="爆瓜网 - 吃瓜爆料在线"
          className="w-full h-full object-cover object-top"
          title="爆瓜网 - 吃瓜爆料在线"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-0">
            <div className="lg:w-[60%]">
              <h1 className="text-white font-heading font-bold text-4xl md:text-5xl lg:text-6xl leading-tight lg:leading-tight">
                每天三分钟
                <br />
                吃尽全网最劲爆的瓜
                <br />
                <span className="text-primary-400">真实爆料 一网打尽</span>
              </h1>
            </div>

            <div className="lg:w-[40%] flex flex-col items-start lg:pt-8">
              <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md mb-8">
                聚焦网红反差、明星八卦、独家揭秘，每日实时更新劲爆内容。
                不编造、不夸大，只做最有态度的吃瓜社区。
              </p>
              <Link
                to="/category/dujia-jiemi"
                className="group inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/40 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-white/10 hover:border-white/60 transition-all duration-300"
              >
                <span>立即吃瓜</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20a%20red%20carpet%20event%20with%20blurred%20crowds%20and%20camera%20flashes%2C%20abstract%20artistic%20style%2C%20dark%20and%20dramatic%20tones%20with%20crimson%20highlights%2C%20cinematic%20widescreen%20composition%2C%20atmospheric%20and%20mysterious%20vibe&width=1920&height=400&seq=hero-bottom-panorama&orientation=landscape"
          alt=""
          className="w-full h-[200px] md:h-[280px] object-cover object-top opacity-40"
          aria-hidden="true"
        />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>
    </section>
  );
}